/**
 * TOOLKIT NAVIGATION — shared model for the three tools.
 *
 * Every tool gets a way back to the hub and a switcher naming the other two.
 * The DATA lives here; each tool renders it in its own visual language (the
 * Roadmap and Story Bible are ink/parchment/gold, Marketing Compass is
 * slate/teal), so there is no shared component fighting two design systems.
 */

/**
 * The three tools, in AUTHOR-JOURNEY order: you plan the book, then you publish
 * it, then you sell it. This matches the order the Squarespace homepage already
 * presents, so product and marketing tell the same story.
 *
 * `stage` is the eyebrow label shown above each hub card.
 * `short` is used below the `sm` breakpoint — three full product names plus a
 * licence chip and a sign-out button do not fit a phone header.
 * `flag` is the featureFlags key gating each (null = always available).
 */
export const TOOLS = [
  { id: 'planner',   stage: 'Pre-launch',  name: 'Story Bible',          short: 'Bible',     href: '/plot-planner',       flag: 'storyBible' },
  { id: 'roadmap',   stage: 'Launch',      name: 'Publishing Checklist', short: 'Checklist', href: '/publishing-roadmap', flag: null },
  { id: 'marketing', stage: 'Post-launch', name: 'Marketing Compass',    short: 'Compass',   href: '/marketing',          flag: 'marketingCompass' },
];

/**
 * The other two tools, as switcher entries.
 *
 * A tool whose flag is off is returned `available: false` — the caller renders
 * it disabled with a "Soon" marker and MUST NOT navigate. Showing it greyed
 * rather than hiding it tells members what is coming; navigating would land
 * them on a "coming soon" page, which is a worse answer than a disabled chip.
 *
 * The Publishing Checklist has no flag: it is the tool the plan is built around
 * and is always available.
 *
 * @param {string} currentId  the tool doing the rendering
 * @param {object} flags      from useFeatureFlags()
 */
export function switcherFor(currentId, flags = {}) {
  return TOOLS
    .filter((t) => t.id !== currentId)
    .map((t) => ({
      ...t,
      available: t.flag ? flags[t.flag] === true : true,
    }));
}

/** Where "Your tools" goes — the hub is the root of World 1. */
export const HUB_HREF = '/';
